export const openCenteredModal = (payload) => {
  return { type: "OPEN_CENTERED_MODAL", payload };
};

export const closeCenteredModal = () => {
  return { type: "CLOSE_CENTERED_MODAL" };
};
